export default {
  modal: {
    defaultTitle: "課金のお知らせ",
    defaultMessage: "ダッシュボードで課金状況を管理してください。",
    primaryLabel: "ダッシュボードへ",
    secondaryLabel: "閉じる",
  },
  notices: {
    oneOffExpiring: {
      title: "クレジットがまもなく失効します",
      message:
        "一回限りのクレジットは 3 日以内に失効します。継続して分析するには更新してください。",
      primaryLabel: "今すぐ更新",
      secondaryLabel: "後で",
    },
    lowCredits: {
      title: "クレジット残量が少ないです",
      message:
        "残りクレジットが 5 未満です。高度な分析を続けるにはチャージしてください。",
      primaryLabel: "チャージする",
      secondaryLabel: "今はしない",
    },
    insufficientCredits: {
      title: "クレジットが不足しています",
      message:
        "この機能には {requiredCredits} クレジットが必要ですが、現在 {totalCredits} しかありません。",
      primaryLabel: "チャージする",
      secondaryLabel: "キャンセル",
    },
    trialCreditsGranted: {
      title: "ウェルカムクレジットが届きました！",
      message: "PhotoScope をお試しいただくために {granted} クレジットを付与しました。画像をアップロードして始めましょう。",
      primaryLabel: "今すぐ始める",
      secondaryLabel: "後で",
    },
    trialCreditsGrantedGeneric: {
      title: "ウェルカムクレジットが届きました！",
      message: "アカウントにトライアルクレジットが追加されました。画像をアップロードして始めましょう。",
      primaryLabel: "今すぐ始める",
      secondaryLabel: "後で",
    },
    creditReminder: {
      title: "クレジットが待っています",
      message: "トライアルクレジットをまだご利用いただいていません。画像をアップロードして PhotoScope をお試しください。",
      primaryLabel: "今すぐアップロード",
      secondaryLabel: "後で通知",
    },
  },
};
